import { ReactElement } from 'react';
import { FormPageHeaderProps } from '../FormPageHeader';
import { useSettingsPageHeader } from '../../state/SettingsPage/useSettingsPageHeader';

export interface SettingsPageHeaderProps extends FormPageHeaderProps {}

export type SettingsPageHeaderElement = ReactElement<
  SettingsPageHeaderProps,
  typeof SettingsPageHeader
>;

export function SettingsPageHeader(_props: SettingsPageHeaderProps) {
  return null;
}

SettingsPageHeader.useSettingsPageHeader = useSettingsPageHeader;
SettingsPageHeader.displayName = 'SettingsPageHeader';
